module App.HiLO.Services {
    'use strict';
    export class ReferenceDataService {
        public static $inject = [
            '$http',
            '$q',
            '$injector',
            'app.common.services.apiService'

        ];

        constructor(private $q: angular.IQService,
            private $http: angular.IHttpService,
            private $injector: angular.auto.IInjectorService ) {
            this.$http = $injector.get<angular.IHttpService>('$http');
        };


        public getData() {
         return this.$http.get('Data/PredecessorOrganisations.json');
        }
    }

    angular
        .module('app.hilo.services')
        .service('app.hilo.services.referenceDataService', ReferenceDataService);
}